class SettingsController {
    constructor() {
        "ngInject";
    }
}

export const settingsComponent = {
    controller : SettingsController,
    template : '<div ui-view="main"></div>'
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/settings.component.ts